export default __webpack_public_path__ + "static/media/stakingImg.c1e38f7e.png";